module.exports = __webpack_public_path__ + "static/josh_brown-0758dfc059930d03a59a5a8986d92dc1.png";